// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingSpinner_root__Uzx0J","spin":"LoadingSpinner_spin__awe_R"};